/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  createAutoResolveTemplate(template) {
    return axios.post(
      `/api/v1/accounts/${this.accountIdFromRoute}/auto_resolve_template`,
      { template }
    );
  }

  getAutoResolveTemplateStatus(inboxId) {
    return axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/auto_resolve_template`,
      {
        params: { inbox_id: inboxId },
      }
    );
  }

  updateAutoResolveTemplateConfig({ inboxId, enabled, language }) {
    return axios.patch(
      `/api/v1/accounts/${this.accountIdFromRoute}/auto_resolve_template`,
      {
        inbox_id: inboxId,
        enabled,
        language,
      }
    );
  }

  createCallPermissionTemplate(template) {
    return axios.post(
      `/api/v1/accounts/${this.accountIdFromRoute}/call_permission_template`,
      { template }
    );
  }

  getCallPermissionTemplateStatus(inboxId) {
    return axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/call_permission_template`,
      {
        params: { inbox_id: inboxId },
      }
    );
  }

  getAvailableCallPermissionTemplates(inboxId) {
    return axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/call_permission_template/templates`,
      {
        params: { inbox_id: inboxId },
      }
    );
  }

  selectCallPermissionTemplate({ inboxId, templateName }) {
    return axios.patch(
      `/api/v1/accounts/${this.accountIdFromRoute}/call_permission_template/select`,
      {
        inbox_id: inboxId,
        template_name: templateName,
      }
    );
  }
}

export default new AccountAPI();
